import React from 'react'
import { useNavigate } from 'react-router-dom'
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react'

const PaymentCancel: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-dark-800 rounded-lg p-8 border border-dark-700">
          <div className="flex justify-center mb-6">
            <XCircle className="h-16 w-16 text-red-500" />
          </div>
          
          <h1 className="text-2xl font-bold text-white mb-4">
            Płatność została anulowana
          </h1>
          
          <p className="text-gray-400 mb-6">
            Nie martw się! Możesz spróbować ponownie w dowolnym momencie.
            Żadne opłaty nie zostały pobrane z Twojego konta.
          </p>

          <div className="space-y-3">
            <button
              onClick={() => navigate('/licenses')}
              className="w-full bg-primary text-white py-3 rounded-lg hover:bg-primary/90 transition-colors flex items-center justify-center"
            >
              <CreditCard className="mr-2 h-4 w-4" />
              Spróbuj ponownie
            </button>
            
            <button
              onClick={() => navigate('/dashboard')}
              className="w-full bg-dark-700 text-gray-300 py-3 rounded-lg hover:bg-dark-600 transition-colors flex items-center justify-center"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Wróć do Dashboard
            </button>
          </div>

          <div className="mt-6 pt-6 border-t border-dark-600">
            <p className="text-sm text-gray-500">
              Masz pytania? Skontaktuj się z nami:
              <br />
              <a href="mailto:support@presentclic.com" className="text-primary hover:underline">
                support@presentclic.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentCancel